<template>
  <div class="h-full w-full max-w-screen-xs mx-auto relative">
    <SmartMatchAi @next="next" @close="decline" />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';

import SmartMatchAiSuccess from '@/components/smart-match-ai/smart-match-ai/components/smart-match-ai-success/SmartMatchAiSuccess.vue';
import SmartMatchAi from '@/components/smart-match-ai/smart-match-ai/SmartMatchAi.vue';
import { myProfileApi } from '@/services/api/my-profile/my-profile-api';
import { bq } from '@/services/bq/bq';
import { useModal } from '@/services/modal/modal';
import { dispatch } from '@/store/store-helper';

const props = defineProps<{
  source: 'dialogue' | 'messages' | 'activity';
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const pageName = 'smart_match_ai_page';

function close() {
  emit('close');
}

function decline() {
  bq.track('user_action', {
    page_name: pageName,
    action_name: 'decline_ai_click',
    block: 'product',
    source: props.source,
  });

  close();
}

async function next() {
  bq.track('user_action', {
    page_name: pageName,
    action_name: 'accept_ai_click',
    block: 'product',
    source: props.source,
  });

  await myProfileApi.setSettingsAi(true);

  await dispatch('actionGetState');

  close();

  useModal(() => ({
    component: SmartMatchAiSuccess,
    props: {
      source: props.source,
    },
  })).showModal();
}

onMounted(() => {
  bq.track('page_show', {
    page_name: pageName,
    block: 'product',
    source: props.source,
  });
});
</script>
